import { render, staticRenderFns } from "./sg-link.vue?vue&type=template&id=065deb5f&"
import script from "./sg-link.vue?vue&type=script&lang=js&"
export * from "./sg-link.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports